import { render, staticRenderFns } from "./create-material.vue?vue&type=template&id=de0a307e&scoped=true"
import script from "./create-material.vue?vue&type=script&lang=js"
export * from "./create-material.vue?vue&type=script&lang=js"
import style0 from "./create-material.vue?vue&type=style&index=0&id=de0a307e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de0a307e",
  null
  
)

export default component.exports